// extracted by mini-css-extract-plugin
module.exports = {"anchor":"styles__anchor___2CX4F","span":"styles__span___Ug2My","active":"styles__active___2wnNv"};